import { useEffect } from "react";
import "./popup.css";

const PopupInferior = ({ mensaje, visible, onClose, duracion = 2000 }) => {
  useEffect(() => {
    if (!visible) return;

    const timer = setTimeout(() => {
      onClose();
    }, duracion);

    return () => clearTimeout(timer);
  }, [visible, duracion, onClose]);

  if (!visible) return null;

  return (
    <div className="popup-inferior-negro">
      {mensaje}
    </div>
  );
};

export default PopupInferior;
